module.exports = __webpack_public_path__ + "static/media/splashBack.fc82f47a.jpeg";